import { render } from "./ManualCategoryForm.vue?vue&type=template&id=930ff600"
import script from "./ManualCategoryForm.vue?vue&type=script&lang=js"
export * from "./ManualCategoryForm.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__